function Spinner({ hidden }) {
  const classes = ['spinner'];
  if (hidden) {
    classes.push('hidden');
  }
  return (
    <div className={classes.join(' ')}>
      <div className="spinner__circle" />
    </div>
  );
}

export default Spinner;
